import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RecherchePage from "../pages/recherche/page";
import PraticienPage from "../pages/praticien/page";
import MentionsLegales from "../pages/legal/MentionsLegales";
import CguCgv from "../pages/legal/CguCgv";
import Confidentialite from "../pages/legal/Confidentialite";
import ValidateAppointmentPage from "../pages/appointment/page";
import AdminPage from "../pages/admin/page";
import AdminLoginPage from "../pages/admin/LoginPage";
import AdminProfilePage from "../pages/admin/ProfilePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/recherche",
    element: <RecherchePage />,
  },
  {
    path: "/praticien/:id",
    element: <PraticienPage />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/cgu",
    element: <CguCgv />,
  },
  {
    path: "/politique-de-confidentialite",
    element: <Confidentialite />,
  },
  {
    path: "/rdv/valider",
    element: <ValidateAppointmentPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin/profile",
    element: <AdminProfilePage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/:city/:district/:specialty",
    element: <RecherchePage />,
  },
  {
    path: "/:city/:district",
    element: <RecherchePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;